import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';

const Component = ({autoStatuses, selectedAutoStatus, onContextMenu}) => {
    const getClassName = (autoStatus) => {
        let className = 'context-menu';
        if (selectedAutoStatus && autoStatus.id === selectedAutoStatus.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSUnresolvedVariable,JSValidateTypes
    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell className="date_from">Начальный статус</TableCell>
                    <TableCell className="date_to">Конечный статус</TableCell>
                    <TableCell className="interval">Интервал (дн.)</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {autoStatuses.map((autoStatus) => (
                        <TableRow key={autoStatus.id} className={getClassName(autoStatus)}
                                  onContextMenu={onContextMenu(autoStatus)}
                        >
                            <TableCell className="date_from">{autoStatus.status_from.status}</TableCell>
                            <TableCell className="date_to">{autoStatus.status_to.status}</TableCell>
                            <TableCell className="interval">{autoStatus.interval}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    autoStatuses: PropTypes.array.isRequired,
    selectedAutoStatus: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
